import React from "react";
import { COMPONENTS } from "../../constants/chatConstants";

export default function DialogContactsSVG({ component }) {
    return (
        <svg width="28" viewBox="0 0 37.427 31.034">
            <g transform="translate(0 13.593)">
                <g>
                    <path
                        d="M31.945,232.492H28.281a5.468,5.468,0,0,0-1.441.193,5.487,5.487,0,0,0-4.889-3.006H15.476a5.487,5.487,0,0,0-4.889,3.006,5.468,5.468,0,0,0-1.441-.193H5.482A5.489,5.489,0,0,0,0,237.975v5.857a3.293,3.293,0,0,0,3.289,3.289H34.137a3.293,3.293,0,0,0,3.289-3.289v-5.857A5.489,5.489,0,0,0,31.945,232.492Zm-21.951,2.67v9.765h-6.7a1.1,1.1,0,0,1-1.1-1.1v-5.857a3.293,3.293,0,0,1,3.289-3.289H9.146a3.279,3.279,0,0,1,.86.115C10,234.92,9.993,235.041,9.993,235.163Zm15.248,9.765H12.186v-9.765a3.293,3.293,0,0,1,3.289-3.289h6.476a3.293,3.293,0,0,1,3.289,3.289Zm9.993-1.1a1.1,1.1,0,0,1-1.1,1.1h-6.7v-9.765c0-.122-.005-.242-.013-.362a3.282,3.282,0,0,1,.86-.115h3.664a3.293,3.293,0,0,1,3.289,3.289Z"
                        transform="translate(0 -229.68)"
                        fill={component === COMPONENTS.CONTACT ? "#000000" : "#959baa"}
                    />
                </g>
            </g>
            <g transform="translate(2.443 6.051)">
                <g>
                    <path
                        d="M38.286,126.5a4.872,4.872,0,1,0,4.872,4.872A4.877,4.877,0,0,0,38.286,126.5Zm0,7.551a2.679,2.679,0,1,1,2.679-2.679A2.682,2.682,0,0,1,38.286,134.055Z"
                        transform="translate(-33.414 -126.504)"
                        fill={component === COMPONENTS.CONTACT ? "#000000" : "#959baa"}
                    />
                </g>
            </g>
            <g transform="translate(12.205 0)">
                <g>
                    <path
                        d="M173.471,43.729a6.509,6.509,0,1,0,6.509,6.509A6.516,6.516,0,0,0,173.471,43.729Zm0,10.824a4.316,4.316,0,1,1,4.316-4.316A4.321,4.321,0,0,1,173.471,54.553Z"
                        transform="translate(-166.962 -43.729)"
                        fill={component === COMPONENTS.CONTACT ? "#000000" : "#959baa"}
                    />
                </g>
            </g>
            <g transform="translate(25.241 6.051)">
                <g>
                    <path
                        d="M350.166,126.5a4.872,4.872,0,1,0,4.872,4.872A4.877,4.877,0,0,0,350.166,126.5Zm0,7.551a2.679,2.679,0,1,1,2.679-2.679A2.682,2.682,0,0,1,350.166,134.055Z"
                        transform="translate(-345.294 -126.504)"
                        fill={component === COMPONENTS.CONTACT ? "#000000" : "#959baa"}
                    />
                </g>
            </g>
        </svg>
    );
}
